import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const DeleteIntSchls = () => {
    const [internationalSchools, setInternationalSchools] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchDeletedIntSchls();
    }, []);

    const fetchDeletedIntSchls = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/internationalSchools/deleted');
            const data = await response.json();
            setInternationalSchools(data);
        } catch (error) {
            console.error('Error fetching deleted international schools:', error);
        }
    };

    const handleRestore = async (schoolId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to restore this international school?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/internationalSchools/restore/${schoolId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setInternationalSchools(internationalSchools.filter(school => school.id !== schoolId));
                        Swal.fire({
                            title: "Restored!",
                            text: "The international school has been restored.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to restore international school');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to restore the international school.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error restoring international school:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to restore the international school.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handlePermanentDelete = async (schoolId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete the international school. This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete permanently!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/internationalSchools/delete/permanent/${schoolId}`, {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        setInternationalSchools(internationalSchools.filter(school => school.id !== schoolId));
                        Swal.fire({
                            title: "Deleted!",
                            text: "The international school has been permanently deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete international school permanently');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to permanently delete the international school.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting international school permanently:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to permanently delete the international school.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter international schools based on search term
    const filteredIntSchools = internationalSchools.filter(school =>
        (school.intschlName && school.intschlName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (school.commonPhone && school.commonPhone.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (school.commonEmail && school.commonEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (school.website && school.website.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (
        <div>
            <AdminDashboard />

            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>DELETE INTERNATIONAL SCHOOLS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                            <tr>
                                    <th>School Name</th>
                                    <th>Contact Person</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredIntSchools.map((school) => (
                                <tr key={school.id}>
                                    <td>{school.intschlName}</td>
                                    <td>{school.commonPhone}</td>
                                    <td>{school.commonEmail}</td>
                                        <td>
                                            <a href={school.website} target="_blank" rel="noopener noreferrer">
                                                Visit Website
                                            </a>
                                        </td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='restore-details' onClick={() => handleRestore(school.id)}>RESTORE</a>
                                            <a href="#!" id='del-details' onClick={() => handlePermanentDelete(school.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteIntSchls;
